import { Component } from '@angular/core';
import { DxToolbarModule, DxPopoverModule, DxButtonModule } from 'devextreme-angular';
import { Auth } from '../../services/auth.service';

@Component({
  selector: 'app-navbar',
  imports: [
    DxToolbarModule,
    DxPopoverModule,
    DxButtonModule,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: true
})
export class NavbarComponent {
  legendVisible = false;

  constructor(public auth: Auth) { }

  logoutButtonOptions = {
    icon: 'login',
    stylingMode: 'text',
    text: 'Logout',
    onClick: () => this.logout()
  };

  async logout() {
    try {
      if (this.auth)
        // logout may return success = false, not handled ATM!
        await this.auth.logoutUser();
    } catch (err) {
      console.error('Logout in backend failed', err);
    }
    
    sessionStorage.clear();
    localStorage.clear();
    
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    });

    // Reload 
    window.location.reload();
  }

}
